import apiClient from './AxiosHttp';

const adminListProperties = (params = '') => {
    return apiClient.get(`/houses/admin/properties/${params}`);
};

const adminCreateProperty = (data) => {
    return apiClient.post('/houses/admin/properties/', data);
};

const adminGetProperty = (id) => {
    return apiClient.get(`/houses/admin/properties/${id}/`);
};

const adminUpdateProperty = (id, data) => {
    return apiClient.patch(`/houses/admin/properties/${id}/`, data);
};

const adminDeleteProperty = (id) => {
    return apiClient.delete(`/houses/admin/properties/${id}/`);
};

const adminListCategories = () => {
    return apiClient.get('/houses/admin/categories/');
};

const adminCreateCategory = (data) => {
    return apiClient.post('/houses/admin/categories/', data);
};

const adminGetCategory = (id) => {
    return apiClient.get(`/houses/admin/categories/${id}/`);
};

const adminUpdateCategory = (id, data) => {
    return apiClient.patch(`/houses/admin/categories/${id}/`, data);
};

const adminDeleteCategory = (id) => {
    return apiClient.delete(`/houses/admin/categories/${id}/`);
};

const adminListAmenities = () => {
    return apiClient.get('/houses/admin/amenities/');
};

const adminCreateAmenity = (data) => {
    return apiClient.post('/houses/admin/amenities/', data);
};

const adminGetAmenity = (id) => {
    return apiClient.get(`/houses/admin/amenities/${id}/`);
};

const adminUpdateAmenity = (id, data) => {
    return apiClient.patch(`/houses/admin/amenities/${id}/`, data);
};

const adminDeleteAmenity = (id) => {
    return apiClient.delete(`/houses/admin/amenities/${id}/`);
};

const propertyStatatistics = () => {
    return apiClient.get('/houses/admin/stats/');
}

const uploadPropertyImages = (propertyId, formData) => {
    return apiClient.post(`/houses/admin/properties/${propertyId}/gallery/upload/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const deletePropertyImages = (propertyId, data) => {
    return apiClient.delete(`/houses/admin/properties/${propertyId}/gallery/delete/`, { data });
};

const createBooking = (data) => {
    return apiClient.post('/houses/bookings/create/', data);
};

const updateBooking = (id, data) => {
    return apiClient.patch(`/houses/admin/bookings/${id}/`, data);
};

const listBookings = (params = '') => {
    return apiClient.get(`/houses/admin/bookings/${params}`);
}

const adminServices = {
    adminListProperties,
    adminCreateProperty,
    adminGetProperty,
    adminUpdateProperty,
    adminDeleteProperty,

    adminListCategories,
    adminCreateCategory,
    adminGetCategory,
    adminUpdateCategory,
    adminDeleteCategory,

    adminListAmenities,
    adminCreateAmenity,
    adminGetAmenity,
    adminUpdateAmenity,
    adminDeleteAmenity,

    propertyStatatistics,

    uploadPropertyImages,
    deletePropertyImages,

    createBooking,
    updateBooking,
    listBookings,
};

export default adminServices;